module.exports = __webpack_public_path__ + "img/biaoben.e1140203.jpg";